import { and, any, equals, filter, includes, isNil, map, or, type } from 'ramda';
import { useEffect } from 'react';

import { doesNotExist, exists } from '@utils/general';

export interface useExcludedCallbackParams<Type> {
	value?: Type;
	callback: (T?: Type) => void;
	list?: Type[];
}

export default <Type>({ value, callback, list = undefined }: useExcludedCallbackParams<Type>) => {
	useEffect(() => {
		if (or(doesNotExist(value), isNil(list))) {
			return;
		}

		if (includes(value, list)) {
			return;
		}

		const isIncluded = filter<string | unknown[]>((item: string | unknown[]) => {
			return includes(value, item);
		});

		if (
			and(
				or(equals(type(value), 'String'), equals(type(value), 'Array')),
				any(exists)(isIncluded(list))
			)
		) {
			return;
		}

		callback(value);
	}, [value, list]);
};
